export function isRunningInBrowser(): boolean {
  return typeof window !== 'undefined';
} 

export function getClient() {
  if (isWindowsApp()) {
      return 'windows-app'
  } else if (isRunningInPWAOrWindowsApp()) {
      return 'pwa'
  } else {
      return 'web'
  }
}

export function isWindowsApp() {
  if (isRunningInBrowser()) {
      return document?.referrer.includes("app-info://platform/microsoft-store") // TODO: sometimes referrer gets updated
  }
  return false
}

export function isRunningInPWAOrWindowsApp() {
  if (!isRunningInBrowser()) {
      return false
  }
  return window.matchMedia('(display-mode: standalone)').matches
}

